import styled from 'styled-components/macro'
import { FullPage } from 'styles'

export const ClientsStyled = styled(FullPage)``
